import React from 'react';

import useDialogs from 'components/Dialog/useDialogs';

import SharedDialogContext from './SharedDialogContext';
import SharedDialogSelectorContext from './SharedDialogSelectorContext';

export default function SharedDialogProvider(props)
{
  const [dialog, selector] = useDialogs(props.dialogs);

  return (
    <SharedDialogSelectorContext.Provider value={selector}>
      <SharedDialogContext.Provider value={dialog}>
        {props.children}
      </SharedDialogContext.Provider>
    </SharedDialogSelectorContext.Provider>
  );
}